import React from 'react';
import '../styles/TravelBenefits.css';

const BENEFITS = [
  {
    icon: 'fa-headphones',
    title: 'Customer Assistance',
    text: 'Need help with your booking? Our team is just a call away.',
  },
  {
    icon: 'fa-snowflake-o',
    title: 'Comfortable AC Cabs',
    text: 'Enjoy a comfortable ride in air-conditioned vehicles.',
  },
  {
    icon: 'fa-road',
    title: 'Outstation Travel',
    text: 'Convenient cab options for intercity and long-distance journeys.',
  },
  {
    icon: 'fa-calendar-check-o',
    title: 'Easy Booking',
    text: 'Book your cab with convenient booking options and transparent fare estimates.',
  },
];

const scrollBenefits = (event) => {
  if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
  const scroller = event.currentTarget;
  if (scroller.scrollWidth <= scroller.clientWidth + 1) return;
  const card = scroller.querySelector('.benefit-card');
  if (!card) return;
  const gap = 12;
  const distance = card.getBoundingClientRect().width + gap;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  scroller.scrollBy({
    left: event.key === 'ArrowRight' ? distance : -distance,
    behavior: reduceMotion ? 'auto' : 'smooth',
  });
  event.preventDefault();
};

const TravelBenefits = () => (
  <section className="travel-benefits block-space" aria-labelledby="travel-benefits-heading">
    <div className="container">
      <h2 id="travel-benefits-heading">Why Travel with EasyDropTaxi?</h2>
      <p className="travel-benefits-lead">Comfort. Convenience. Confidence.</p>
      <div
        className="travel-benefits-scroller"
        role="region"
        aria-label="EasyDropTaxi benefits"
        tabIndex={0}
        onKeyDown={scrollBenefits}
      >
        {BENEFITS.map((benefit) => (
          <article key={benefit.title} className="benefit-card">
            <i className={`fa ${benefit.icon}`} aria-hidden="true"></i>
            <div>
              <h3>{benefit.title}</h3>
              <p>{benefit.text}</p>
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default TravelBenefits;
